module.exports = __webpack_public_path__ + "static/media/Triton_II_Fiberglass.f7c7dbf7.pdf";